import { render, staticRenderFns } from "./customer-awaiting-receipt-list.vue?vue&type=template&id=4d5fa2aa"
import script from "./customer-awaiting-receipt-list.vue?vue&type=script&lang=js"
export * from "./customer-awaiting-receipt-list.vue?vue&type=script&lang=js"
import style0 from "./customer-awaiting-receipt-list.vue?vue&type=style&index=0&id=4d5fa2aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports